module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Получаем информацию по свободным местам..."
    }
  }) : _c('div', [_c('h3', [_vm._v("Список заказов на ближайшие две недели")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chunk(_vm.days, 14)), function(chunk) {
    return _c('div', {
      staticClass: "col"
    }, _vm._l((chunk), function(date) {
      return _c('div', {
        staticClass: "card"
      }, [(_vm.isClosed(date)) ? [_c('div', {
        staticClass: "card-header text-danger"
      }, [_vm._v("\n            " + _vm._s(_vm.convertDataToString(date)) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "card-block bg-danger"
      }, [_vm._v("\n            Закрыто\n          ")])] : (_vm.getOrdersByDate(date) && _vm.getOrdersByDate(date).length === 0) ? [_c('div', {
        staticClass: "card-header text-success"
      }, [_vm._v("\n            " + _vm._s(_vm.convertDataToString(date)) + " - все свободно\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "card-block bg-success"
      }, _vm._l((_vm.getFreeTimesAll(date)), function(dateTime) {
        return _c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              _vm.selectDate(dateTime.format('DD.MM.YYYY'), dateTime.format('HH:mm'))
            }
          }
        }, [_vm._v(_vm._s(dateTime.format('HH:mm')))])
      }))] : [_c('div', {
        staticClass: "card-block"
      }, [_c('div', {
        staticClass: "card-header text-warning"
      }, [_vm._v("\n              " + _vm._s(_vm.convertDataToString(date)) + " - местами занято\n            ")]), _vm._v(" "), _vm._l((_vm.getOrdersByDate(date)), function(obj, index) {
        return [(obj.orders.length === 0) ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-1"
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              _vm.selectDate(obj.dateTime.format('DD.MM.YYYY'), obj.dateTime.format('HH:mm'))
            }
          }
        }, [_vm._v("\n                    " + _vm._s(obj.dateTime.format('HH:mm')))])]), _vm._v(" "), _c('div', {
          staticClass: "col"
        }, [_vm._v("Свободно")])]) : _vm._l((obj.orders), function(order) {
          return _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-1"
          }, [_c('button', {
            staticClass: "btn btn-danger btn-sm",
            on: {
              "click": function($event) {
                _vm.selectDate(obj.dateTime.format('DD.MM.YYYY'), order.time)
              }
            }
          }, [_vm._v(_vm._s(order.time))])]), _vm._v(" "), _c('div', {
            staticClass: "col-7"
          }, [_vm._v("\n                  " + _vm._s(order.description) + "\n                ")]), _vm._v(" "), _c('div', {
            staticClass: "col"
          }, [_vm._v("\n                  +7" + _vm._s(order.clientPhone) + " " + _vm._s(order.clientName) + "\n                ")]), _vm._v(" "), _c('div', {
            staticClass: "col"
          }, [_vm._v("\n                 " + _vm._s(order.sum) + " руб.\n                ")])])
        })]
      })], 2)]], 2)
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-74113b32"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcOrdersList.vue
// module id = 1050
// module chunks = 1